import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["value", "changeOnEnd"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AxisType, PointType } from '../enum';
import { Region } from './Region';
export var RangeRegion = /*#__PURE__*/function (_Region) {
  _inherits(RangeRegion, _Region);

  var _super = _createSuper(RangeRegion);

  function RangeRegion() {
    var _this;

    _classCallCheck(this, RangeRegion);

    _this = _super.call(this);
    _this.isTrying = false;
    _this.changeOnEnd = false;
    _this.startValue = 0;
    _this.endValue = 0;
    _this.tryingStartValue = 0;
    _this.tryingEndValue = 0;

    _this.createPoint('start', PointType.RIGHT);

    _this.createPoint('end', PointType.RIGHT);

    return _this;
  }

  _createClass(RangeRegion, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var value = options.value,
          _options$changeOnEnd = options.changeOnEnd,
          changeOnEnd = _options$changeOnEnd === void 0 ? false : _options$changeOnEnd,
          config = _objectWithoutProperties(options, _excluded);

      var sd = this.getPoint('start').getDragging();
      var ed = this.getPoint('end').getDragging();
      var swap = ed && value[0] !== this.startValue && value[1] === this.startValue || sd && value[1] !== this.endValue && value[0] === this.endValue;
      this.changeOnEnd = changeOnEnd;
      this.startValue = value[swap ? 1 : 0] || 0;
      this.endValue = value[swap ? 0 : 1] || 0; // 如果不在拖拽中，就换过来

      if (!this.getDragging()) {
        this.tryingStartValue = 0;
        this.tryingEndValue = 0;
        this.isTrying = false;
      }

      this.getAxis(AxisType.HORIZONTAL).updateAxisConfig(config);
      this.getPoint('start').updatePointValue();
      this.getPoint('end').updatePointValue();
      this.repaint();
    }
  }, {
    key: "setPointValue",
    value: function setPointValue(part, value, virtual) {
      if (part !== 'end' && part !== 'start') {
        throw new Error('range region has two valid part start/end');
      }

      if (this.changeOnEnd && virtual) {
        this[part === 'start' ? 'tryingStartValue' : 'tryingEndValue'] = value.x;
        this.getPoint('start').repaint();
        this.getPoint('end').repaint();
        return;
      }

      var start = part === 'start' ? value.x : this.startValue;
      var end = part === 'end' ? value.x : this.endValue;
      this.emit('change', [Math.min(start, end), Math.max(start, end)]);
    }
  }, {
    key: "getPointValue",
    value: function getPointValue(part) {
      if (part !== 'end' && part !== 'start') {
        throw new Error('range region has two valid part start/end');
      }

      if (part === 'end') {
        return {
          x: this.isTrying ? this.tryingEndValue : this.endValue,
          y: 0
        };
      }

      return {
        x: this.isTrying ? this.tryingStartValue : this.startValue,
        y: 0
      };
    }
  }, {
    key: "isValueSelected",
    value: function isValueSelected(value) {
      return this.isAxisSelected(AxisType.HORIZONTAL, value.x);
    }
  }, {
    key: "isAxisSelected",
    value: function isAxisSelected(type, value) {
      if (type === AxisType.HORIZONTAL) {
        var _this$getSelectedRegi = this.getSelectedRegion(),
            _this$getSelectedRegi2 = _slicedToArray(_this$getSelectedRegi, 2),
            start = _this$getSelectedRegi2[0],
            end = _this$getSelectedRegi2[1];

        return value <= end.x && value >= start.x;
      }

      return false;
    }
  }, {
    key: "getPointByOffset",
    value: function getPointByOffset(offset) {
      var deltaS = Math.abs(this.getPoint('start').getOffset().x - offset.x);
      var deltaE = Math.abs(this.getPoint('end').getOffset().x - offset.x);
      return deltaE <= deltaS ? this.getPoint('end') : this.getPoint('start');
    }
  }, {
    key: "getSelectedRegion",
    value: function getSelectedRegion() {
      var start = this.isTrying ? this.tryingStartValue : this.startValue;
      var end = this.isTrying ? this.tryingEndValue : this.endValue;
      return [{
        x: Math.min(start, end),
        y: 0
      }, {
        x: Math.max(start, end),
        y: 0
      }];
    }
  }, {
    key: "getSelectedOffset",
    value: function getSelectedOffset() {
      var start = this.getPoint('start').getOffset().x;
      var end = this.getPoint('end').getOffset().x;
      return [{
        x: Math.min(start, end),
        y: 0
      }, {
        x: Math.max(start, end),
        y: 0
      }];
    }
  }]);

  return RangeRegion;
}(Region);